import {
	constructEndpoint,
	put,
} from '@atlassian/jira-common-rest/src/internal/simplified/1.0/projects/id/summary/rest';
import type {
	ProjectDetailsRequestBodySimplified,
	ProjectDetailsData,
	ProjectDetailsRequestBody,
} from '@atlassian/jira-common-rest/src/internal/simplified/1.0/projects/id/summary/types';
import { performPutRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { toErrorId, toErrorMessage } from '@atlassian/jira-project-settings-apps-common/src/types';
import { famaCatchAndLogFetchError } from '@atlassian/jira-project-settings-apps-common/src/util/catch-and-log-fetch-error';
import { PACKAGE_NAME } from '../../model/constants';
import type { ProjectContext } from './types';

export const updateProjectDetailsSimplified = (
	context: ProjectContext,
	data: ProjectDetailsRequestBodySimplified,
): Promise<ProjectDetailsData> =>
	famaCatchAndLogFetchError(
		put(context.baseUrl)(context.projectId, data),
		PACKAGE_NAME,
		toErrorId('updateProjectDetailsSimplified'),
		toErrorMessage('Failed to update project details'),
	);

export const updateProjectDetails = (
	context: ProjectContext,
	data: ProjectDetailsRequestBody,
): Promise<ProjectDetailsData> => {
	const url = constructEndpoint(context.baseUrl, context.projectId);
	return famaCatchAndLogFetchError(
		performPutRequest(url, {
			body: JSON.stringify(data),
		}),
		PACKAGE_NAME,
		toErrorId('updateProjectDetails'),
		toErrorMessage('Failed to update project details'),
	);
};
